<template>
	<div class='lmAes-intro'>
    <h2>MoPaaS 大模型应用引擎</h2>
    <div class="box">
      <div class="content">
        <p>无缝集成大模型和自主的知识库(高性能向量数据库Lotus+知识图谱)、RAG 引擎(Falcon)和 Agent 框架(Acton)等工具链，加速企业A应用的落地。</p>
        <p>·企业智能搜索：连通数据和发掘资源</p>
        <p>·智能工作助手：提升员工办公效率</p>
        <p>·工作流程自动化：提升企业生产力</p>
      </div>
      <img src="../../assets/images/lmaesIntro.png"/>
      </div>
	</div>
</template>

<script>
	export default {
		name: 'LmAesIntro'
	}
</script>

<style scoped>
    .lmAes-intro {
      background: #ffffff;
      padding: 4.16vw 0;
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    .lmAes-intro h2 { 
      max-width: 80vw;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #3963B3;
      line-height: 24px;
      text-align: center;
      font-style: normal;
    }
    .lmAes-intro .box {
      width: 100%;
      margin: 20px auto 0;
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    .lmAes-intro .box img {
      width: 50vw;
      height: 50vw;
      margin-top: 20px;
    }
    .lmAes-intro .box .content {
      width: 75vw;
      font-family: PingFangSC, PingFang SC;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      text-align: left;
      font-style: normal;
    }
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/LmAesIntro.vue